import React from 'react';
import './Contact.css'

const Contact = () => {
  return (
    <div className='contact-container'>
      <h1 className='contact-header'>This page is under construction</h1>
      <p class='contact-info'>Please contact me at sakisandra.c@gmail.com</p>
    </div>
  )
}

export default Contact